const { Buffer } = require('buffer');

global.Buffer = Buffer;